export const index = `
<div>
  <nav
    id="topNav"
    class="app_navbar top-navbar"
    style="position: sticky; justify-content: flex-end"
  >
    <div class="app_navbar_logo_wrap">
      <div class="zinologo"></div>
      <div class="mobileview_top_menu">
        <div title="Open menu" class="nav_icon_outer">
          <svg
            width="22px"
            height="22px"
            fill="#667085"
            version="1.1"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect height="4" rx="2" width="22" x="1" y="2"></rect>
            <rect height="4" rx="2" width="22" x="1" y="18"></rect>
            <rect height="4" rx="2" width="22" x="1" y="10"></rect>
          </svg>
        </div>
      </div>
    </div>
    <div class="nav_menu_alignment" style="width: auto; margin-left: auto">
      <div class="top_menu_outerBox desktopview_top_menu">
        <a class="navbar_menu_item menu_item_page_active" href="./index.html">
          <div class="navbar_menu_text">Basic</div>
        </a>
        <a aria-current="page" class="navbar_menu_item" href="./rvTable.html">
          <div class="navbar_menu_text">Blocks</div>
        </a>
      </div>
      <div class="navbar_icon_container">
        <div></div>
        <div class="navbar_icon_wrap">
          <div title="Open notifications" class="nav_icon_outer">
            <span class="nav_icon_count nav_icon_style" style="display: none"
              >0</span
            >
            <svg
              width="22px"
              height="22px"
              fill="var(--nav-item-color)"
              version="1.1"
              viewBox="0 0 32 32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path
                  d="M5.33301 25.3332V22.6665H7.99967V13.3332C7.99967 11.4887 8.55523 9.84984 9.66634 8.4165C10.7775 6.98317 12.2219 6.04428 13.9997 5.59984V4.6665C13.9997 4.11095 14.1941 3.63873 14.583 3.24984C14.9719 2.86095 15.4441 2.6665 15.9997 2.6665C16.5552 2.6665 17.0275 2.86095 17.4163 3.24984C17.8052 3.63873 17.9997 4.11095 17.9997 4.6665V5.59984C19.7775 6.04428 21.2219 6.98317 22.333 8.4165C23.4441 9.84984 23.9997 11.4887 23.9997 13.3332V22.6665H26.6663V25.3332H5.33301ZM15.9997 29.3332C15.2663 29.3332 14.6386 29.0721 14.1163 28.5498C13.5941 28.0276 13.333 27.3998 13.333 26.6665H18.6663C18.6663 27.3998 18.4052 28.0276 17.883 28.5498C17.3608 29.0721 16.733 29.3332 15.9997 29.3332ZM10.6663 22.6665H21.333V13.3332C21.333 11.8665 20.8108 10.6109 19.7663 9.5665C18.7219 8.52206 17.4663 7.99984 15.9997 7.99984C14.533 7.99984 13.2775 8.52206 12.233 9.5665C11.1886 10.6109 10.6663 11.8665 10.6663 13.3332V22.6665Z"
                ></path>
              </g>
            </svg>
          </div>
        </div>
        <div title="Chat">
          <div class="navbar_icon_wrap">
            <div class="nav_icon_outer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="#667085"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 20l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 11H6v-2h12v2zm0-3H6V8h12v2z"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="profile_dropdown_container">
          <div class="profile_dropdown">
            <div title="Open profile" class="nav_icon_outer">
              <div class="navbar_user_avatar one-letter">P</div>
            </div>
            <div class="profile_popover">
              <div title="Prajwal"><span>Prajwal</span></div>
              <div title="prajwal.bu@getzino.com">
                <span>prajwal.bu@getzino.com</span>
              </div>
              <div class="cursor-pointer"><span>Apps List</span></div>
              <div class="cursor-pointer">
                <span>Change Password</span>
              </div>
              <div class="cursor-pointer"><span>Log out</span></div>
              <div><span>Version : 0.0.660</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <div class="body" style="max-width: 100%; overflow: auto">
    <div class="center-page">
      <div
        class="section"
        style="
          height: 3864px;
          position: relative;
          margin-top: 0px;
          margin-bottom: 0px;
        "
      >
        <div
          class="z-img-cover block"
          style="
            height: 272px;
            left: 8px;
            position: absolute;
            top: 104px;
            width: 1576px;
          "
        >
          <div
            class="z-font-weight-extra z-font-xl z-text-primary-400 element-label"
            id=""
            style="
              height: 36px;
              left: 36px;
              position: absolute;
              top: 20px;
              width: 192px;
            "
          >
            <span>Button Type</span>
          </div>
          <div
            class="z-font-weight-extra z-font-xl z-text-primary-400 element-label"
            id=""
            style="
              height: 36px;
              left: 36px;
              position: absolute;
              top: 140px;
              width: 192px;
            "
          >
            <span>Button Size</span>
          </div>
          <button
            class="z-btn-primary element-button z-btn z-btn undefined"
            style="left: 36px; position: absolute; top: 60px; width: 168px"
          >
            Primary
          </button>
          <button
            class="z-btn-danger element-button z-btn z-btn undefined"
            style="left: 1384px; position: absolute; top: 56px; width: 150px"
          >
            Danger
          </button>
          <button
            class="z-btn-outline element-button z-btn z-btn undefined"
            style="left: 560px; position: absolute; top: 56px; width: 150px"
          >
            Outline
          </button>
          <button
            class="z-btn-disabled element-button z-btn z-btn undefined"
            style="left: 840px; position: absolute; top: 56px; width: 150px"
          >
            Disabled
          </button>
          <button
            class="z-btn-success element-button z-btn z-btn undefined"
            style="left: 1128px; position: absolute; top: 56px; width: 150px"
          >
            Success
          </button>
          <button
            class="z-btn-secondary element-button z-btn z-btn undefined"
            style="left: 304px; position: absolute; top: 56px; width: 150px"
          >
            Secondary
          </button>
          <button
            class="z-btn-small element-button z-btn z-btn undefined"
            style="left: 32px; position: absolute; top: 184px; width: 150px"
          >
            Small
          </button>
          <button
            class="z-btn-medium element-button z-btn z-btn undefined"
            style="left: 296px; position: absolute; top: 184px; width: 150px"
          >
            Medium
          </button>
          <button
            class="z-btn-large element-button z-btn z-btn undefined"
            style="left: 560px; position: absolute; top: 192px; width: 150px"
          >
            Large
          </button>
        </div>
        <div
          class="z-img-cover block"
          style="
            height: 1536px;
            left: 8px;
            position: absolute;
            top: 504px;
            width: 1576px;
          "
        >
          <div
            class="z-font-weight-extra z-font-xl z-text-primary-400 element-label"
            id=""
            style="
              height: 36px;
              left: 48px;
              position: absolute;
              top: 24px;
              width: 192px;
            "
          >
            <span>Font Size</span>
          </div>
          <div
            class="z-img-cover z-bg-neutral-200 block"
            style="
              height: 104px;
              left: 48px;
              position: absolute;
              top: 72px;
              width: 1480px;
            "
          >
            <div
              class="z-font-xs element-label"
              id=""
              style="
                height: 24px;
                left: 36px;
                position: absolute;
                top: 48px;
                width: 120px;
              "
            >
              <span>Extra Small</span>
            </div>
            <div
              class="z-font-xl element-label"
              id=""
              style="
                height: 36px;
                left: 1320px;
                position: absolute;
                top: 40px;
                width: 180px;
              "
            >
              <span>Extra Large</span>
            </div>
            <div
              class="z-font-lg element-label"
              id=""
              style="
                height: 24px;
                left: 1040px;
                position: absolute;
                top: 40px;
                width: 120px;
              "
            >
              <span>Large</span>
            </div>
            <div
              class="z-font-md element-label"
              id=""
              style="
                height: 24px;
                left: 680px;
                position: absolute;
                top: 48px;
                width: 120px;
              "
            >
              <span>Medium</span>
            </div>
            <div
              class="z-font-sm element-label"
              id=""
              style="
                height: 24px;
                left: 336px;
                position: absolute;
                top: 48px;
                width: 120px;
              "
            >
              <span>Small</span>
            </div>
          </div>
          <div
            class="z-img-cover z-bg-neutral-200 block"
            style="
              height: 96px;
              left: 48px;
              position: absolute;
              top: 276px;
              width: 1480px;
            "
          >
            <div
              class="z-font-weight-light element-label"
              id=""
              style="
                height: 24px;
                left: 36px;
                position: absolute;
                top: 48px;
                width: 120px;
              "
            >
              <span>Weight-Normal</span>
            </div>
            <div
              class="z-font-weight-bold element-label"
              id=""
              style="
                height: 36px;
                left: 1320px;
                position: absolute;
                top: 40px;
                width: 192px;
              "
            >
              <span>Weight-700</span>
            </div>
            <div
              class="z-font-weight-semibold element-label"
              id=""
              style="
                height: 24px;
                left: 1032px;
                position: absolute;
                top: 40px;
                width: 156px;
              "
            >
              <span>Weight-600</span>
            </div>
            <div
              class="element-label"
              id=""
              style="
                height: 24px;
                left: 680px;
                position: absolute;
                top: 40px;
                width: 120px;
              "
            >
              <span>Weight-400</span>
            </div>
            <div
              class="z-font-weight-regular element-label"
              id=""
              style="
                height: 24px;
                left: 328px;
                position: absolute;
                top: 40px;
                width: 120px;
              "
            >
              <span>Weight-300</span>
            </div>
          </div>
          <div
            class="z-img-cover z-bg-neutral-200 block"
            style="
              height: 104px;
              left: 48px;
              position: absolute;
              top: 468px;
              width: 1480px;
            "
          >
            <div
              class="z-text-underline element-label"
              id=""
              style="
                height: 24px;
                left: 36px;
                position: absolute;
                top: 40px;
                width: 120px;
              "
            >
              <span>Underline</span>
            </div>
            <div
              class="z-text-no-decoration element-label"
              id=""
              style="
                height: 24px;
                left: 1048px;
                position: absolute;
                top: 40px;
                width: 120px;
              "
            >
              <span>None</span>
            </div>
            <div
              class="z-text-line-through element-label"
              id=""
              style="
                height: 24px;
                left: 680px;
                position: absolute;
                top: 40px;
                width: 120px;
              "
            >
              <span>Linethrough</span>
            </div>
            <div
              class="z-text-overline element-label"
              id=""
              style="
                height: 24px;
                left: 336px;
                position: absolute;
                top: 48px;
                width: 120px;
              "
            >
              <span>Overline</span>
            </div>
          </div>
          <div
            class="z-text-primary-400 z-font-weight-extra z-font-xl element-label"
            id=""
            style="
              height: 36px;
              left: 48px;
              position: absolute;
              top: 420px;
              width: 204px;
            "
          >
            <span>Text Decoration</span>
          </div>
          <div
            class="z-text-primary-400 z-font-weight-extra z-font-xl element-label"
            id=""
            style="
              height: 36px;
              left: 48px;
              position: absolute;
              top: 228px;
              width: 204px;
            "
          >
            <span>Text Weight</span>
          </div>
          <div
            class="z-text-primary-400 z-font-weight-extra z-font-xl element-label"
            id=""
            style="
              height: 36px;
              left: 48px;
              position: absolute;
              top: 612px;
              width: 288px;
            "
          >
            <span>Text Align Horizontal</span>
          </div>
          <div
            class="z-img-cover z-bg-neutral-200 z-flex-vertical-center block"
            style="
              height: 120px;
              left: 48px;
              position: absolute;
              top: 660px;
              width: 1488px;
            "
          >
            <div
              class="z-flex-left z-bg-primary-100 z-p-4 element-label"
              id=""
              style="
                height: 72px;
                left: 24px;
                position: absolute;
                top: 24px;
                width: 348px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
            <div
              class="z-flex-center z-bg-primary-100 z-p-4 element-label"
              id=""
              style="
                height: 72px;
                left: 520px;
                position: absolute;
                top: 24px;
                width: 372px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
            <div
              class="z-flex-right z-bg-primary-100 z-p-4 element-label"
              id=""
              style="
                height: 72px;
                left: 1040px;
                position: absolute;
                top: 16px;
                width: 348px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
          </div>
          <div
            class="z-text-primary-400 z-font-weight-extra z-font-xl element-label"
            id=""
            style="
              height: 36px;
              left: 48px;
              position: absolute;
              top: 804px;
              width: 288px;
            "
          >
            <span>Text Align Vertical</span>
          </div>
          <div
            class="z-img-cover z-bg-neutral-200 z-flex-vertical-center block"
            style="
              height: 200px;
              left: 48px;
              position: absolute;
              top: 852px;
              width: 1488px;
            "
          >
            <div
              class="z-bg-primary-100 z-flex-top z-p-4 element-label"
              id=""
              style="
                height: 144px;
                left: 36px;
                position: absolute;
                top: 24px;
                width: 324px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
            <div
              class="z-bg-primary-100 z-flex-vertical-center z-p-4 element-label"
              id=""
              style="
                height: 144px;
                left: 528px;
                position: absolute;
                top: 24px;
                width: 360px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
            <div
              class="z-bg-primary-100 z-flex-bottom z-p-4 element-label"
              id=""
              style="
                height: 144px;
                left: 1040px;
                position: absolute;
                top: 24px;
                width: 384px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
          </div>
          <div
            class="z-text-primary-400 z-font-weight-extra z-font-xl element-label"
            id=""
            style="
              height: 36px;
              left: 48px;
              position: absolute;
              top: 1116px;
              width: 288px;
            "
          >
            <span>Padding Styles</span>
          </div>
          <div
            class="z-img-cover z-bg-neutral-200 block"
            style="
              height: 312px;
              left: 48px;
              position: absolute;
              top: 1176px;
              width: 1480px;
            "
          >
            <div
              class="z-bg-primary-100 z-p-1 element-label"
              id=""
              style="
                height: 80px;
                left: 40px;
                position: absolute;
                top: 32px;
                width: 352px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
            <div
              class="z-bg-primary-100 z-p-2 element-label"
              id=""
              style="
                height: 80px;
                left: 512px;
                position: absolute;
                top: 32px;
                width: 384px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
            <div
              class="z-bg-primary-100 z-p-3 element-label"
              id=""
              style="
                height: 88px;
                left: 1024px;
                position: absolute;
                top: 32px;
                width: 408px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
            <div
              class="z-bg-primary-100 z-p-4 element-label"
              id=""
              style="
                height: 112px;
                left: 40px;
                position: absolute;
                top: 160px;
                width: 360px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
            <div
              class="z-bg-primary-100 z-p-5 element-label"
              id=""
              style="
                height: 104px;
                left: 512px;
                position: absolute;
                top: 152px;
                width: 408px;
              "
            >
              <span
                >Liven up your web layout wireframes and mockups with one of
                these lorem ipsum generators.</span
              >
            </div>
          </div>
        </div>
        <div
          class="z-font-weight-extra z-font-xl z-flex-vertical-center z-text-neutral-1000 element-label"
          style="
            height: 48px;
            left: 8px;
            position: absolute;
            top: 40px;
            width: 348px;
          "
        >
          Buttons
        </div>
        <div
          class="z-font-weight-extra z-font-xl z-flex-vertical-center z-text-neutral-1000 element-label"
          style="
            height: 48px;
            left: 16px;
            position: absolute;
            top: 432px;
            width: 348px;
          "
        >
          Text Styles
        </div>
        <div
          class="z-img-cover block"
          style="
            height: 368px;
            left: 8px;
            position: absolute;
            top: 2144px;
            width: 1576px;
          "
        >
          <div
            class="z-text-primary-400 z-font-weight-extra z-font-xl element-label"
            id=""
            style="
              height: 36px;
              left: 40px;
              position: absolute;
              top: 20px;
              width: 288px;
            "
          >
            <span>Image Style</span>
          </div>
          <div
            class="z-img-cover z-bg-neutral-200 z-img-fill block"
            style="
              height: 248px;
              left: 40px;
              position: absolute;
              top: 72px;
              width: 1496px;
            "
          >
            <img
              src="https://t3.ftcdn.net/jpg/06/99/46/60/360_F_699466075_DaPTBNlNQTOwwjkOiFEoOvzDV0ByXR9E.jpg"
              alt="Image"
              id=""
              class="z-border-radius-none z-img-cover element-image"
              style="
                height: auto;
                left: 24px;
                position: absolute;
                top: 60px;
                width: 168px;
              "
            />
            <img
              src="https://t3.ftcdn.net/jpg/06/99/46/60/360_F_699466075_DaPTBNlNQTOwwjkOiFEoOvzDV0ByXR9E.jpg"
              alt="Image"
              id=""
              class="z-border-radius-pill z-img-cover element-image"
              style="
                height: auto;
                left: 1272px;
                position: absolute;
                top: 56px;
                width: 168px;
              "
            /><img
              src="https://t3.ftcdn.net/jpg/06/99/46/60/360_F_699466075_DaPTBNlNQTOwwjkOiFEoOvzDV0ByXR9E.jpg"
              alt="Image"
              id=""
              class="z-border-radius-full z-img-cover element-image"
              style="
                height: auto;
                left: 1024px;
                position: absolute;
                top: 56px;
                width: 156px;
              "
            />
            <img
              src="https://t3.ftcdn.net/jpg/06/99/46/60/360_F_699466075_DaPTBNlNQTOwwjkOiFEoOvzDV0ByXR9E.jpg"
              alt="Image"
              id=""
              class="z-border-radius-lg z-img-cover element-image"
              style="
                height: auto;
                left: 776px;
                position: absolute;
                top: 56px;
                width: 168px;
              "
            /><img
              src="https://t3.ftcdn.net/jpg/06/99/46/60/360_F_699466075_DaPTBNlNQTOwwjkOiFEoOvzDV0ByXR9E.jpg"
              alt="Image"
              id=""
              class="z-img-cover z-border-radius-md element-image"
              style="
                height: auto;
                left: 512px;
                position: absolute;
                top: 56px;
                width: 168px;
              "
            />
            <img
              src="https://t3.ftcdn.net/jpg/06/99/46/60/360_F_699466075_DaPTBNlNQTOwwjkOiFEoOvzDV0ByXR9E.jpg"
              alt="Image"
              id=""
              class="z-border-radius-sm z-img-cover element-image"
              style="
                height: auto;
                left: 256px;
                position: absolute;
                top: 56px;
                width: 168px;
              "
            />
          </div>
        </div>
        <div
          class="z-font-weight-extra z-font-xl z-flex-vertical-center z-text-neutral-1000 element-label"
          style="
            height: 48px;
            left: 8px;
            position: absolute;
            top: 2088px;
            width: 348px;
          "
        >
          Image Styles
        </div>
        <div
          class="z-font-weight-extra z-font-xl z-flex-vertical-center z-text-neutral-1000 element-label"
          style="
            height: 48px;
            left: 16px;
            position: absolute;
            top: 2560px;
            width: 348px;
          "
        >
          Border Styles
        </div>
        <div
          class="z-img-cover block"
          style="
            height: 1248px;
            left: 16px;
            position: absolute;
            top: 2616px;
            width: 1568px;
          "
        >
          <div
            class="z-img-cover z-bg-neutral-200 block"
            style="
              height: 184px;
              left: 48px;
              position: absolute;
              top: 72px;
              width: 1488px;
            "
          >
            <div
              class="z-bg-neutral-100 z-border-radius-none z-flex-center element-label"
              id=""
              style="
                height: 132px;
                left: 40px;
                position: absolute;
                top: 32px;
                width: 132px;
              "
            >
              <span>Radius None</span>
            </div>
            <div
              class="z-border-radius-sm z-flex-center z-border-size-sm z-border-solid z-bg-neutral-100 element-label"
              id=""
              style="
                height: 132px;
                left: 296px;
                position: absolute;
                top: 32px;
                width: 132px;
              "
            >
              <span>Radius Small</span>
            </div>
            <div
              class="z-bg-neutral-100 z-border-radius-md z-border-neutral-900 z-flex-center z-border-solid z-border-size-sm element-label"
              id=""
              style="
                height: 132px;
                left: 608px;
                position: absolute;
                top: 32px;
                width: 144px;
              "
            >
              <span>Radius Medium</span>
            </div>
            <div
              class="z-bg-neutral-100 z-border-radius-lg z-border-neutral-1000 z-flex-center z-border-solid element-label"
              id=""
              style="
                height: 132px;
                left: 928px;
                position: absolute;
                top: 32px;
                width: 144px;
              "
            >
              <span>Radius Large</span>
            </div>
            <div
              class="z-border-radius-full z-border-neutral-1000 z-flex-center z-border-solid z-border-size-sm element-label"
              id=""
              style="
                height: 132px;
                left: 1224px;
                position: absolute;
                top: 32px;
                width: 144px;
              "
            >
              <span>Radius Full</span>
            </div>
          </div>
          <div
            class="z-text-primary-400 z-font-weight-extra z-font-xl element-label"
            id=""
            style="
              height: 36px;
              left: 48px;
              position: absolute;
              top: 24px;
              width: 288px;
            "
          >
            <span>Border Radius</span>
          </div>
          <div
            class="z-text-primary-400 z-font-weight-extra z-font-xl element-label"
            id=""
            style="
              height: 36px;
              left: 48px;
              position: absolute;
              top: 276px;
              width: 288px;
            "
          >
            <span>Border Style</span>
          </div>
          <div
            class="z-img-cover z-bg-neutral-200 block"
            style="
              height: 208px;
              left: 48px;
              position: absolute;
              top: 336px;
              width: 1488px;
            "
          >
            <div
              class="z-bg-neutral-100 z-border-neutral-1000 z-border-solid z-flex-center element-label"
              id=""
              style="
                height: 132px;
                left: 60px;
                position: absolute;
                top: 36px;
                width: 132px;
              "
            >
              <span>Border Solid</span>
            </div>
            <div
              class="z-bg-neutral-100 z-border-neutral-1000 z-border-dotted z-flex-center element-label"
              id=""
              style="
                height: 132px;
                left: 304px;
                position: absolute;
                top: 40px;
                width: 132px;
              "
            >
              <span>Border Dotted</span>
            </div>
            <div
              class="z-bg-neutral-100 z-border-neutral-900 z-border-dashed z-flex-center element-label"
              id=""
              style="
                height: 132px;
                left: 608px;
                position: absolute;
                top: 40px;
                width: 144px;
              "
            >
              <span>Border Dashed</span>
            </div>
            <div
              class="z-bg-neutral-100 z-border-neutral-1000 z-border-double z-flex-center element-label"
              id=""
              style="
                height: 132px;
                left: 936px;
                position: absolute;
                top: 40px;
                width: 156px;
              "
            >
              <span>Border Double</span>
            </div>
          </div>
          <div
            class="z-text-primary-400 z-font-weight-extra z-font-xl element-label"
            id=""
            style="
              height: 36px;
              left: 48px;
              position: absolute;
              top: 888px;
              width: 288px;
            "
          >
            <span>Shadow</span>
          </div>
          <div
            class="z-text-primary-400 z-font-weight-extra z-font-xl element-label"
            id=""
            style="
              height: 36px;
              left: 48px;
              position: absolute;
              top: 588px;
              width: 288px;
            "
          >
            <span>Border Width</span>
          </div>
          <div
            class="z-img-cover z-bg-neutral-200 block"
            style="
              height: 216px;
              left: 48px;
              position: absolute;
              top: 648px;
              width: 1488px;
            "
          >
            <div
              class="z-bg-neutral-100 z-border-neutral-1000 z-flex-center z-border-size-sm z-border-solid element-label"
              id=""
              style="
                height: 132px;
                left: 60px;
                position: absolute;
                top: 36px;
                width: 132px;
              "
            >
              <span>Border Small</span>
            </div>
            <div
              class="z-bg-neutral-100 z-border-neutral-1000 z-flex-center z-border-size-md z-border-solid element-label"
              id=""
              style="
                height: 132px;
                left: 312px;
                position: absolute;
                top: 32px;
                width: 132px;
              "
            >
              <span>Border Medium</span>
            </div>
            <div
              class="z-bg-neutral-100 z-border-neutral-900 z-flex-center z-border-size-lg z-border-solid element-label"
              id=""
              style="
                height: 132px;
                left: 608px;
                position: absolute;
                top: 32px;
                width: 144px;
              "
            >
              <span>Border Large</span>
            </div>
          </div>
          <div
            class="z-img-cover z-bg-neutral-200 block"
            style="
              height: 224px;
              left: 48px;
              position: absolute;
              top: 936px;
              width: 1488px;
            "
          >
            <div
              class="z-bg-neutral-100 z-border-neutral-1000 z-flex-center z-shadow-sm element-label"
              id=""
              style="
                height: 132px;
                left: 320px;
                position: absolute;
                top: 48px;
                width: 132px;
              "
            >
              <span>Shadow Small</span>
            </div>
            <div
              class="z-bg-neutral-100 z-border-neutral-1000 z-flex-center z-shadow-none element-label"
              id=""
              style="
                height: 132px;
                left: 56px;
                position: absolute;
                top: 48px;
                width: 132px;
              "
            >
              <span>Shadow None</span>
            </div>
            <div
              class="z-bg-neutral-100 z-border-neutral-900 z-flex-center z-shadow-md element-label"
              id=""
              style="
                height: 132px;
                left: 624px;
                position: absolute;
                top: 48px;
                width: 144px;
              "
            >
              <span>Shadow Medium</span>
            </div>
            <div
              class="z-bg-neutral-100 z-border-neutral-1000 z-flex-center z-shadow-lg element-label"
              id=""
              style="
                height: 132px;
                left: 944px;
                position: absolute;
                top: 48px;
                width: 156px;
              "
            >
              <span>Shadow Large</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    style="position: fixed; z-index: 9999; inset: 16px; pointer-events: none"
  ></div>
</div>
`;
